import React, { Fragment } from "react";
import { styled } from "@mui/material/styles";
import { Typography, TextField, Box } from "@mui/material";
import { useTheme } from "@mui/material";

import NextButton from "./NextButton";

import { isDark } from "@common/utils/colors";
import { validateShortAnswerQuestion, updateResponses } from "@common/utils/questionUtils";

const PREFIX = "ShortAnswer";

const classes = {
  header: `${PREFIX}-header`,
  title: `${PREFIX}-title`,
  body: `${PREFIX}-body`,
  textField: `${PREFIX}-textField`,
  required: `${PREFIX}-required`,
  navigation: `${PREFIX}-navigation`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  borderRadius: "0px",
  boxShadow: "none",
  padding: theme.spacing(2, 3),
  backgroundColor: theme.palette.primary.main,

  [`& .${classes.header}`]: {
    marginBottom: "20px",
  },

  [`& .${classes.title}`]: {
    fontWeight: 700,
    color: isDark(theme.palette.primary.main) ? "#FFF" : "#000",
  },

  [`& .${classes.body}`]: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
  },

  [`& .${classes.textField}`]: {
    backgroundColor: "#FFF",
    borderRadius: theme.spacing(0.5),
    boxShadow: theme.bordered ? "none" : theme.shadows[2],
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: theme.bordered ? `1px solid ${theme.palette.secondary.main}` : "none",
      },
      "&:hover fieldset": {
        border: theme.bordered ? `2px solid ${theme.palette.secondary.main}` : "none",
      },
      "&.Mui-focused fieldset": {
        border: theme.bordered ? `2px solid ${theme.palette.secondary.main}` : "none",
      },
    },
  },

  [`& .${classes.required}`]: {
    color: theme.palette.error.main,
  },

  [`& .${classes.navigation}`]: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    padding: theme.spacing(0, 3),
    marginBottom: theme.spacing(2),
  },
}));

const ShortAnswer = ({ question, responses, setResponses, index, total, pageNum, setPageNum }) => {
  const theme = useTheme();

  return (
    <Fragment>
      <StyledBox>
        <div className={classes.header}>
          <Typography
            variant="body1"
            style={{ color: isDark(theme.palette.primary.main) ? "#FFF" : "#676767" }}
          >
            {index} of {total}
          </Typography>
          <Typography variant="h5" className={classes.title}>
            {question.question_title}
          </Typography>
          {question.required && <span className={classes.required}>* Required</span>}
        </div>
        <div className={classes.body}>
          <TextField
            classes={{ root: classes.textField }}
            multiline
            variant="outlined"
            // margin="dense"
            rows={2}
            placeholder="Type your answer here..."
            autoFocus
            value={responses[pageNum].selected_options}
            onChange={(event) =>
              updateResponses(event.target.value, responses, setResponses, pageNum)
            }
          />
        </div>
      </StyledBox>
      <div
        className={classes.navigation}
        style={{
          visibility: validateShortAnswerQuestion(responses[pageNum], question.required)
            ? "visible"
            : "hidden",
        }}
      >
        <NextButton onClickFn={() => setPageNum(pageNum + 1)} />
      </div>
    </Fragment>
  );
};

export default ShortAnswer;
